import { useMemo } from 'react';
import { CatalogConfig, ProductStock } from '@setvi/shared/interfaces';
import { CompanySettingsTypeID } from '@setvi/shared/services/react-query/query/user/types';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { COMPANIES } from 'Enums/Companies';
import { useLocation } from 'react-router-dom';

enum PathOverrides {
  CVET_RFQ = 'rfq-digital-showroom'
}

export const useCatalogConfig = () => {
  const { pathname } = useLocation();
  const { companyData } = useAppContext();

  // #region REMOVE THIS CODE WHEN CONFIG IS UPDATED
  const isSingerOrPJPUser = [
    COMPANIES.SINGER_DEV,
    COMPANIES.SINGER_PROD,
    COMPANIES.PJP_DEV,
    COMPANIES.PJP_PROD
  ].includes(companyData.ID);

  // #endregion

  const config: CatalogConfig =
    companyData.Settings[CompanySettingsTypeID.CatalogConfig]?.Value;
  const invalidConfiguration = Object.keys(config || {})?.length === 0;

  const pathOverrideValues = Object.values(PathOverrides);
  const overrides = useMemo(
    () => pathOverrideValues.some(value => pathname?.includes(value)),
    [pathname, pathOverrideValues]
  );

  let configuration = {} as CatalogConfig;

  if (!invalidConfiguration) {
    const productStock: ProductStock = {
      // @ts-ignore
      show: config.productDetails.stock,
      refresh: isSingerOrPJPUser
    };

    configuration = {
      ...config,
      filters: {
        ...config?.filters,
        customer: {
          ...config?.filters?.customer,
          show: overrides ? false : config?.filters?.customer?.show
        }
      },

      // #region REMOVE THIS CODE WHEN CONFIG IS UPDATED
      productDetails: {
        ...config.productDetails,
        stock: productStock
      },
      product: {
        ...config.product,
        grid: {
          ...config.product.grid,
          stock: productStock
        }
      }
      // #endregion
    };
  }

  return {
    configuration,
    invalidConfiguration
  };
};
